module.exports = __webpack_public_path__ + "static/media/WarRoom.3e50f19b.jpg";